import bg from "../assets/images/about2.png";
import html from "../assets/images/html.png";
import firebase from "../assets/images/firebase.png";
import next from "../assets/images/next.png";
import java from "../assets/images/java.png";
import js from "../assets/images/js.png";
import mysql from "../assets/images/mySQL.png";
import aws from "../assets/images/aws.png";
import me from "../assets/images/me.png";
import { useState } from "react";
import AboutSkill from "./skills/AboutSkill";
import { FaBriefcase } from "react-icons/fa";
import Skills from "./skills/Skills";

export default function About() {
  const skills = [
    { text: "Skills", id: "aws" },
    { text: "Mandla", id: "aboutskill" },
  ];

  const [component, setComponent] = useState(null);

  const renderComponent = () => {
    switch (component) {
      case "aboutskill":
        return <AboutSkill />;
      default:
        return <Skills />;
    }
  };

  return (
    <div
      className="w-full md:w-full pb-8 md:mt-0 px-3 md:py-10 md:gap-4 md:grid  md:grid-cols-3 overflow-hidden md:space-y-0 md:h-screen"
      style={{
        backgroundImage: `url(${bg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <div className="relative md:mt-10 w-full  justify-center py-8 gap-10 flex  items-center md:items-end">
        {skills.map((skill) => {
          return (
            <div className="items-center justify-center md:flex ">
              <div
                className="relative cursor-pointer shadow-lg h-20 w-20 md:h-24 md:w-24 flex items-center justify-center  rounded-full  transition-all ease-linear duration-300 hover:scale-110"
                onClick={() => setComponent(skill.id)}
              >
                <div className="animate-spinBorder flex justify-center items-center w-[100%] h-[100%] shadow-lg rounded-full border-2 border-dashed border-[#080808]"></div>
                <div className="absolute gap-4 flex items-center w-[70%] h-[70%] rounded-full justify-center bg-[#978b72]">
                  {
                    <p className="z-10 cursor-pointer text-white text-xs md:text-sm font-extrabold  transition-all duration-1000 ease-out">
                      {skill.text}
                    </p>
                  }
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/**Top row */}
      <div className=" md:min-h-0  md:pl-32  md:grid col-span-2  ">
        {/**Scroll bar styling */}
        <div
          className="col-span-2 p-4 md:p-10 rounded-lg  bg-[#f2dbb9] overflow-y-auto md:w-[90%] leading-relaxed [&::-webkit-scrollbar]:w-1
  [&::-webkit-scrollbar-track]:bg-[#f2dbb9]
  [&::-webkit-scrollbar-thumb]:bg-[#978b72]
  [&::-webkit-scrollbar-thumb]:rounded-full"
        >
          {renderComponent(component)}
        </div>
      </div>
    </div>
  );
}
